export default {
  common: {
    actions: 'Actions',
    apply: 'Apply',
    filter: 'Filter',
    filters: 'Filters',
    reset_filter: 'Reset filter',
    new: 'New',
    edit: 'Edit',
    delete: 'Delete',
    deleting: 'Deleting...',
    cancel: 'Cancel',
    abbrechen: 'Cancel',
    reset: 'Reset',
    save: 'Save',
    saving: 'Saving...',
    create: 'Create',
    loading: 'Loading...',
    download: 'Download',
    wait: 'Please wait...',
    yes: 'Yes',
    no: 'No',
    none: '(none)',
    noResults: 'No results.',
    itemsPerPage: 'Items per page',
    searchPlaceholder: 'Search for {field}...',
    searchNr: 'Search for number...',
    searchName: 'Search for name...',
    sessionEnd: 'Session ends in',
    search: 'Search',
    expand: 'Expand',
    collapse: 'Collapse',
    expand_sidebar: 'Expand Sidebar',
    collapse_sidebar: 'Collapse Sidebar',
    logout: 'Logout',
    id: 'ID',
    close: 'Close',
    confirm: 'Confirm',
    columns: 'Columns',
    back: 'Back',
    general: 'General',
    logo_full: 'CEETRAC Logo',
    logo_icon: 'CEETRAC Icon',
    link1: 'Link 1',
    link2: 'Link 2',
    link3: 'Link 3',
    selectDate: 'Select date',
    verknuepfen: 'Assign',
    alleVerknuepfen: 'Assign all',
    zurueck: 'Back',
    weiter: 'Next',
    gesamt: 'Total',
    nachweise: 'Certificates',
    remove: 'Remove',
    assign: 'Assign',
    select: 'Please select',
    nr: 'Partner No',
    name: 'Partner Name',
    darkMode: 'Enable dark mode',
    lightMode: 'Enable light mode',
    detail: 'Details',
    date: 'Date',
    datum: 'Date',
    amount: 'Amount',
    unit: 'Unit',
    refresh: 'Refresh',
    noData: 'No data available.',
    noPreview: 'No preview available.',
    entries: 'Entries',
    selectPartner: 'Select customer',
    selectProdukt: 'Select product',
    unsaved_changes: 'Unsaved Changes',
    unsaved_changes_message: 'You have unsaved changes. Do you want to continue without saving?',
    discard: 'Discard',
    standort: 'Location',
    produkt: 'Product',
    volumen: 'Volume',
    fuellstand: 'Fill level',
    delete_warning: 'This action cannot be undone.',
    no_permissions: 'No permissions',
    no_permissions_message: "You don't have the rights to execute this action.",
    ceemas: 'To CEEMAS',
    totals: 'Totals',
    sumsTotal: 'Sum: Total',
    sumsByPage: 'Sum: by Page',
    excelDownloadSuccess: 'Excel document downloaded successfully.',
    excelDownloadError: 'Error downloading the Excel document.',
    recipient: 'Recipient',
    cc: 'Cc',
    send: 'Send',
    nextMonth: 'Next month',
    nextYear: 'Next year',
    previousMonth: 'Previous month',
    previousYear: 'Previous year',
    required: 'Required field',
    loadMore: 'Load more',
    fieldConfig: {
      selectColumnsFor: 'Select table columns for',
      listConfig: 'Column configuration',
      clickToDelete: 'Click to delete',
      delete: 'Delete',
      deleteListConfigExplanation:
        'Note: To delete a configuration, you must subsequently click `Save`.',
      name: 'Name',
      noSelectedPropertiesExplanation: 'No columns selected.',
      selectedProperties: 'Selected columns:',
      dragToReorder: 'Drag to reorder',
      availableProperties: 'Available columns:',
      createNew: 'Create new',
      deleteListConfigNotification: 'Configuration deleted',
      saved: 'Configuration saved'
    }
  },
  register: {
    username: 'Login',
    firstName: 'First name',
    lastName: 'Last name',
    password: 'Password',
    password2: 'Repeat password',
    register: 'Register',
    terms: 'General terms and conditions',
    street: 'Street',
    houseNr: 'Housenumber',
    city: 'City',
    zipCode: 'ZIP',
    country: 'Country',
    messages: {
      success: 'Registration was successful.',
      notFound: 'Invitation could not be found.',
      pwdMismatch: 'Passwords do not match.'
    }
  },
  auth: {
    login: 'Login',
    logout: 'Logout',
    username: 'Username',
    password: 'Password',
    reset_pwd: 'Change password',
    newPassword: 'New password',
    confirmNewPassword: 'Repeat new password',
    forgot_password: 'Forgot password?',
    login_error: 'Login failed',
    two_factor_authentication: '2-Factor Authentication',
    enter_code: 'Please enter the code from your authenticator app.',
    enter_credentials: 'Please enter your login credentials.',
    enter_password: 'You have to change your password.',
    scan_qr_code:
      'Scan this QR code with your authenticator app (e.g. Google Authenticator or Microsoft Authenticator)',
    authentication_code: 'Authentication code',
    enter_code_from_app: 'Enter the code from your authenticator app',
    verify: 'Verify',
    verifying: 'Verifying...',
    tenant_selection: 'Tenant selection',
    select_tenant: 'Select the tenant you want to work with',
    search_tenants: 'Search tenants...',
    of: 'of',
    found: 'found',
    available: 'available',
    last_used: 'Last used',
    last_used_short: 'Last used',
    administrator: 'Administrator',
    more_tenants: 'More tenants',
    available_tenants: 'Available tenants',
    no_tenants_found: 'No tenants found',
    check_search_input: 'Please check your search input',
    select_and_continue: 'Select and continue',
    maintenance_error: 'Maintenance active. Login currently not possible.'
  },
  navigation: {
    home: 'Home',
    settings: 'Settings',
    stammdaten: 'Master Data',
    bewegungsdaten: 'Movement Data',
    reports: 'Reports',
    layouts: 'Layouts',
    help: 'Help / FAQ',
    user: 'User',
    bewegungsdaten_children: {
      einlieferungen: 'Deliveries',
      ablieferungen: 'Disposals',
      abholungen: 'Collections',
      bestaende: 'Inventory',
      nachweisbescheinigungen: 'Certification Records',
      tankstelle_bestand: 'Gas Station Overview',
      nachweisverfolgung: 'Certificate Tracking',
      zertifikate: 'Certificates',
      bilanzen: 'PoC allotment',
      pocs: 'PoCs',
      import: 'Import',
      nachweisverteilung: 'Certificate allocation'
    },
    stammdaten_children: {
      allgemein: 'General',
      partner: 'Partners',
      standorte: 'Locations',
      produkte: 'Products',
      zertifizierungen: 'Certifications',
      import: 'Import'
    },
    reports_children: {
      liste: 'List of Reports',
      auswertungen: 'Evaluations',
      logmeldungen: 'Log Messages',
      ytdOverview: 'YTD overview'
    },
    layouts_children: {
      about: 'About',
      accordion: 'Accordion',
      badge: 'Badge',
      breadcrumb: 'Breadcrumb',
      button_group: 'Button Group',
      button_icons: 'Button Icons',
      buttons: 'Buttons',
      data_display: 'Data Display',
      date_picker: 'Date Picker',
      input: 'Input',
      pagination: 'Pagination',
      sidebar: 'Sidebar',
      table: 'Table',
      tabs_group: 'Tabs Group'
    },
    help_children: {
      documentation: 'Documentation',
      faq: 'FAQ',
      videos: 'Help Videos'
    },
    user_children: {
      change_password: 'Change Password',
      '2fa_reset': '2FA Reset',
      settings: 'Settings',
      messages: 'Messages',
      administration: 'User Administration',
      mandanten: 'Tenant Management',
      roles: 'Roles',
      release_notes: 'Release Notes',
      dashboard: 'Dashboard'
    },
    import: 'Import'
  },
  settings: {
    title: 'Settings',
    description: 'Customize the application to your needs',
    language: 'Language',
    german: 'German',
    english: 'English',
    compactMode: 'Compact Mode',
    compactModeDescription: 'Reduced spacing for more content',
    theme: 'Theme',
    privacy: 'Privacy',
    personal: {
      title: 'Personal Settings',
      description: 'Customize the basic settings to your needs',
      timezone: 'Timezone',
      dateFormat: 'Date Format',
      itemsPerPage: 'Items per Page',
      entries: 'Entries'
    },
    notifications: {
      title: 'Notifications',
      description: 'Manage your notification settings',
      email: {
        title: 'Email',
        description: 'Receive important updates via email'
      },
      browser: {
        title: 'Browser',
        description: 'Desktop notifications in browser'
      }
    },
    display: {
      title: 'Display',
      description: 'Customize the appearance',
      compactMode: {
        title: 'Compact Mode',
        description: 'Reduced spacing for more content'
      }
    },
    timezones: {
      berlin: 'Berlin (UTC+1)',
      london: 'London (UTC)',
      newYork: 'New York (UTC-5)'
    },
    dateFormats: {
      german: '31.12.2023',
      iso: '2023-12-31',
      us: '12/31/2023'
    },
    buttons: {
      save: 'Save',
      saving: 'Saving...'
    },
    messages: {
      saveSuccess: 'Settings were successfully saved',
      loadError: 'Error loading settings',
      saveError: 'An unexpected error occurred'
    }
  },
  permissions: {
    title: 'Permissions',
    description: 'Overview of your permissions',
    errors: {
      loadRoles: 'Roles could not be loaded.',
      loadUsers: 'Users could not be loaded.',
      loadPermissions: 'Permissions could not be loaded.'
    },
    roles: {
      title: 'Assigned roles',
      description: 'Roles assigned to you',
      assigned: 'Assigned',
      notAssigned: 'Not assigned'
    },
    locations: {
      title: 'Assigned locations',
      description: 'Locations assigned to you',
      allLocations: '(all locations)'
    },
    management: {
      title: 'Permissions management',
      description: 'Manage permissions for users',
      userSelection: 'User selection',
      userSelectionDescription: 'Select a non-administrative user to manage their permissions.',
      selectUser: 'Select user',
      chooseUser: 'Choose user...',
      userInfo: 'User information',
      standort: 'Location',
      allLocations: '(all locations)',
      addStandort: 'Add location',
      permissions: 'Permissions',
      permissionsDescription: 'Manage user permissions',
      canRead: 'View',
      canWrite: 'Edit',
      noUserSelected: 'No user selected',
      saveSuccess: 'Permissions have been saved successfully.',
      saveError: 'There was an error while saving permissions.',
      categories: {
        standorte: 'Locations',
        stammdaten: 'Master Data',
        bewegungsdaten: 'Transaction Data',
        nachweiseUndBerichte: 'Certificates & Reports'
      },
      roles: {
        produkte: 'Products',
        standorte: 'Locations',
        partner: 'Partners',
        abholungen: 'Shipments',
        einlieferungen: 'Deliveries',
        ablieferungen: 'Transactions',
        bestaende: 'Stock',
        nachweise: 'Certificate records',
        nachweisverfolgung: 'Certificate tracking',
        berichte: 'Reports',
        cockpit: 'Gas station overview',
        zertifikate: 'Certificates',
        bilanzen: 'PoC allotments',
        poc: 'PoCs',
        ytdberichte: 'YTD report'
      }
    }
  },
  views: {
    allgemein: {
      mandant: {
        title: 'Tenant',
        description: 'Update the master data of the tenant.',
        identifier: 'Identifier',
        name: 'Name',
        strasse: 'Street',
        hausNr: 'House-Nr',
        plz: 'Postal code',
        stadt: 'City',
        land: 'Country',
        email: 'Email'
      }
    },
    pocs: {
      title: 'PoCs',
      noData: 'No PoCs found.',
      download: 'Download PoC',
      downloadXml: 'Download PoC XML',
      messages: {
        patchSuccess: 'PoC-document successfully recreated.',
        patchError: 'PoC-document could not be recreated due to an error.'
      },
      patch: {
        title: 'Recreate PoC-document',
        text: 'The PoC-document will be recreated. Are you sure?'
      },
      filter: {
        title: 'Filter',
        apply: 'Apply',
        reset: 'Reset',
        standort: 'Location',
        produkt: 'Product',
        partner: 'Customer',
        zeitraum: 'Period',
        allProducts: '(all products)',
        allStandorte: '(all locations)',
        allPartners: '(all customers)'
      },
      columns: {
        id: 'ID',
        draft: 'Draft',
        mandantLand: 'Country',
        mandantName: 'Supplier name',
        standortCode: 'Location code',
        standort: 'Location name',
        produkt: 'Product name',
        jahr: 'Year',
        partner: 'Recipient name',
        zeitraum: 'Period',
        nummer: 'Unique Number PoC',
        ausstellungsdatum: 'Date Issuance PoC',
        versanddatum: 'Date of dispatch',
        deliveryNoteNr: 'Delivery Note Number',
        nachweisNr: 'Unique Number PoS',
        scheme: 'Scheme',
        supplier: 'Supplier Name',
        supplierAddress: 'Supplier Adress',
        supplierNachweisNr: 'Supplier Certificate Number',
        recipient: 'Recipient Name',
        recipientAddress: 'Recipient Adress',
        recipientContractNr: 'Recipient Contract Number',
        ausgangsstelle: 'Address of dispatch',
        lieferstelle: 'Address of receiving point',
        dateDispatch: 'Date of dispatch',
        ausgangsstelleGleichSupplier: 'Same as address of supplier',
        feedstock: 'Feedstock',
        additionalInformation: 'Additional Info',
        origin: 'Country of Origin',
        biomenge: 'Quantity (Bio)',
        biomasseArt: 'Product',
        zugewieseneBiomenge: 'Product-Quantity',
        gesamtMenge: 'Total quantity product',
        energy: 'Energy content',
        lcv: 'LCV',
        dichte: 'Product density',
        euRedCompliant: 'EU RED III Compliant',
        redSustainableCultivation: 'Red Sustainable Cultivation',
        redWasteFlag: 'Red waste flag',
        totalDefaultValueAccToRed: 'Total default value according to RED III applied',
        ghgEmissionEc: 'Eec',
        ghgEmissionLanduse: 'El',
        ghgEmissionProcessed: 'Ep',
        ghgEmissionTd: 'Etd',
        ghgEmissionU: 'Eu',
        ghgEmissionSca: 'Esca',
        ghgEmissionCcs: 'Eccs',
        ghgEmissionCcr: 'Eccr',
        e: 'E',
        allocatedHeat: 'Allocated heat',
        allocatedElectricity: 'Allocated electricity',
        savingsFuelsTransport: 'Biofuels for transport',
        savingsLiquidsElectricity: 'Biomass fuels for the production of electricity',
        savingsFuelsElectricity: 'Bioliquids for electricity',
        savingsLiquidsHeatProduction: 'Savings fules heat production',
        savingsFuelsHeatProduction: 'Savings liquids head production',
        savingsFuelsCoalHeatProduction: 'Savings fules coal head production'
      }
    },
    bilanzen: {
      title: 'PoC allotment',
      createTitle: 'Create',
      createConflict:
        'There is an open allotment that needs to be closed before a new one can be created.',
      editTitle: 'Edit allotment',
      unlockTitle: 'Unlock allotment',
      unlockConfirm: 'Are you sure you want to unlock this allotment?',
      deleteTitle: 'Delete allotment',
      deleteConfirm: 'Are you sure you want to delete this allotment?',
      closeTitle: 'Close allotment',
      closeConfirm:
        'Are you sure you want to close this allotment? Changes will then no longer be possible.',
      sendTitle: 'Send PoCs',
      sendText:
        'You are about to start a bulk mailing of the available PoCs. You can specify recipients that will receive copies of (all) messages. Multiple email addresses can be separated by semicolons.',
      sendPosTitle: 'Send PoCs',
      sendPosText:
        'Please specify one or more recipients. Multiple email addresses can be separated by semicolons.',
      sftpSendTitle: 'Send via sFTP',
      sftpSendConfirm: 'Do you want to start the sFTP upload?',
      closePosTitle: 'Close position',
      closePosConfirm:
        'Are you sure you want to close this position? Changes will then no longer be possible.',
      lockTitle: 'Lock allotment',
      lockText: 'Once the allotment has been locked, PoCs for the relevant period will be created.',
      lockConfirm: 'Are you sure you want to lock this allotment?',
      lockPosTitle: 'Lock position',
      lockPosText:
        'Once the position has been locked, PoCs for the relevant period will be created.',
      lockPosConfirm: 'Are you sure you want to lock this position?',
      unlockPosTitle: 'Unlock position',
      unlockPosConfirm: 'Are you sure you want to unlock this position?',
      noData: 'No allotments found.',
      invalidData:
        'Incorrect data. Please enter a priority and a valid value for bio quantity and/or bio content.',
      lock: 'Lock',
      unlock: 'Unlock',
      close: 'Close',
      download: 'Download certificate',
      recipient: 'Recipient',
      cc: 'Cc',
      pdf: 'Include PDF',
      xml: 'Include XML',
      filter: {
        apply: 'Apply',
        reset: 'Reset',
        standort: 'Location',
        produkt: 'Product',
        allStandorte: '(all locations)',
        allProducts: '(all products)'
      },
      status: {
        offen: 'open',
        gesperrt: 'locked',
        geschlossen: 'closed'
      },
      messages: {
        bulkSent: 'Bulk mailing was successfully started.',
        bulkSentError: 'Bulk mailing could not be started.',
        sent: 'PoCs have been sent successfully.',
        sentError: 'PoCs could not be sent.',
        sftpSent: 'sFTP upload was successful.',
        sftpError: 'sFTP upload failed. {error}',
        biomengeOverflowError: 'More bio-quantity used than available.',
        maxBeimischungOverflowError: 'More bio-quantity assigned than possible (max {0}%).'
      },
      columns: {
        standort: 'Location',
        standortNr: 'Location no.',
        standortCode: 'Location code',
        produkt: 'Product',
        produktNr: 'Product no.',
        mandantName: 'Client',
        mandantLand: 'Client country',
        von: 'From',
        bis: 'To',
        vonMonat: 'From (month)',
        vonJahr: 'From (year)',
        bisMonat: 'To (month)',
        bisJahr: 'To (year)',
        partner: 'Customer',
        group: 'Group',
        status: 'Status',
        statusCode: 'Status code',
        zeitraum: 'Period',
        gesamt: 'Total quantity (L)',
        menge: 'Quantity',
        gesamtBiomenge: 'Total Bio-Quantity (L)',
        zusatzBiomenge: 'Voluntary Quantity',
        biogehalt: 'Bio-Quantity (%)',
        priority: 'Priority',
        restBiomenge: 'Remaining Bio-Quantity (L)',
        gesamtZugewiesen: 'Assigned (L)',
        zugewiesen: 'Assigned',
        nachweise: 'Certificates',
        ytdPocMenge: 'YTD PoC-Quantity',
        ytdSollMenge: 'YTD Mandatory-Quantity',
        ytdDiffMenge: 'YTD Difference',
        ytdZusatzMenge: 'YTD Voluntary Quantity',
        ytdPocTotalMenge: 'YTD PoC-Quantity (all locations)',
        ytdSollTotalMenge: 'YTD Mandatory-Quantity (all locations)',
        ytdDiffTotalMenge: 'YTD Difference (all locations)'
      },
      ansicht: {
        anzeige: 'View',
        kompakt: '(compact)',
        menge: 'Quantity',
        zusatzBiomenge: 'Voluntary-Quantity',
        pocMenge: 'PoC-Quantity',
        ytdMenge: 'YTD-Quantity'
      }
    },
    zertifikate: {
      title: 'Certificates',
      editTitle: 'Edit certificate',
      createTitle: 'Create new certificate',
      deleteTitle: 'Delete certificate',
      deleteConfirm: 'Are you sure you want to delete this certificate?',
      download: 'Download certificate',
      filter: {
        all: '(all)',
        title: 'Filter',
        apply: 'Apply',
        reset: 'Reset',
        nr: 'Nr',
        land: 'Country of origin',
        rohstoff: 'Feedstock',
        produkt: 'Product',
        lieferant: 'Supplier',
        empfaenger: 'Recipient',
        lieferstelle: 'Point of delivery',
        zeitraum: 'Date range'
      },
      status: {
        open: 'open',
        locked: 'locked',
        inProgress: 'in progress',
        inDistribution: 'in distribution',
        completed: 'completed',
        unknown: 'unknown'
      },
      abholungen: {
        title: 'Collections',
        add: 'Assign',
        clear: 'Clear all',
        keineAbholungen: 'No collections available.',
        abholungAuswaehlen: 'Select collection'
      },
      columns: {
        nr: 'Nr',
        status: 'Status',
        thg: 'E (gCO2eq/MJ)',
        nnwEnergie: 'Energy content (MJ)',
        lcv: 'Lower calorific value (MJ/kg)',
        info: 'Additional information',
        waste: 'Raw material is waste (yes/no)',
        sustainable: 'Raw material meets the sustainability criteria (yes/no)',
        menge: 'Quantity (m³ or tons)',
        biomasseArt: 'Biomass-Type',
        biomasseCode: 'Biomass-Code',
        biogehalt: 'Biocontent',
        anbauland: 'Country of origin',
        rohstoff: 'Raw material/feedstock',
        produkt: 'Product',
        zertifizierungsystem: 'Authority',
        ghgEmissionEc: 'Eec (gCO2eq/MJ)',
        ghgEmissionEl: 'El (gCO2eq/MJ)',
        ghgEmissionEp: 'Ep (gCO2eq/MJ)',
        ghgEmissionTd: 'Etd (gCO2eq/MJ)',
        ghgEmissionU: 'Eu (gCO2eq/MJ)',
        ghgEmissionEsca: 'Esca (gCO2eq/MJ)',
        ghgEmissionCcs: 'Eccs (gCO2eq/MJ)',
        ghgEmissionCcr: 'Eccr (gCO2eq/MJ)',
        allocatedHeat: 'Allocated heat (gCO2eq/MJ)',
        allocatedElectricity: 'Allocated electricity (gCO2eq/MJ)',
        totalDefault: 'Total default value according to RED II? (yes/no)',
        datum: 'Date of issuance',
        zeitraum: 'Date period',
        referenzNachweisNr: 'Underlying PoS number',
        scheme: 'PoS compliance scheme',
        supplier: 'Supplier',
        supplierNachweisNr: 'Supplier certificate number',
        recipient: 'Recipient',
        recipientContractNr: 'Recipient contract number',
        ausgangsstelle: 'Address of dispatch/shipping point',
        lieferstelle: 'Address of receiving point',
        lieferungVon: 'Dispatch date (from)',
        lieferungBis: 'Dispatch date (until)',
        mengeGesamt: 'Total delivered quantity (m³ or tons)',
        dichte: 'Density (kg/m³)',
        euRed2Compliant: 'EU RED II compliant',
        file: 'File',
        mandantName: 'Client',
        mandantLand: 'Client country',
        land: 'Country code',
        landName: 'Country of cultivation (name)',
        feedstockId: 'Feedstock ID',
        nnwProduktName: 'By-product name',
        nnwProduktNr: 'By-product no.',
        produktNr: 'Product no.',
        produktVersion: 'Product version',
        zertifizierungssystemId: 'Certification system ID',
        supplierNr: 'Supplier no.',
        recipientNr: 'Recipient no.',
        recipientVersion: 'Recipient version',
        ausgangsstelleGleichSupplier: 'Point of departure = supplier',
        lieferstelleNr: 'Delivery point no.',
        lieferstelleVersion: 'Delivery point version',
        standortCode: 'Site code',
        ghgEmissionEe: 'Eee (gCO2eq/MJ)',
        ghgEmissionEscaBonusCap: 'Esca Bonus Cap (gCO2eq/MJ)'
      }
    },
    tauschpartner: {
      title: 'Partners',
      createTitle: 'Create Partner',
      editTitle: 'Edit Partner',
      deleteTitle: 'Delete Partner',
      deleteConfirm: 'Are you sure you want to delete this partner?',
      confirmNrChange: 'Do you really want to change the partner number?',
      columns: {
        nr: 'Partner No',
        name: 'Name',
        strasse: 'Street',
        hausNr: 'House No',
        plz: 'Postal Code',
        stadt: 'City',
        land: 'Country',
        email: 'Email',
        group: 'Group',
        vertrag: 'Contract-Nr',
        format: 'Preferred PoC-format',
        verbraucher: 'Uses consumer portal',
        code: 'Code',
        version: 'Version',
        mandantName: 'Client',
        mandantLand: 'Client country'
      },
      rules: {
        title: 'Rules',
        noData: 'No rules.',
        clear: 'Remove all',
        add: 'Add rule',
        columns: {
          standort: 'Location',
          priority: 'Priority',
          biogehalt: 'Bio-Content (%)',
          biomenge: 'Bio-Quantity (L)'
        }
      }
    },
    ablieferungen: {
      title: 'Deliveries',
      noData: 'No transactions.',
      createTitle: 'Create New Delivery',
      editTitle: 'Edit Delivery',
      deleteTitle: 'Delete Delivery',
      deleteConfirm: 'Are you sure you want to delete this delivery?',
      createSuccess: 'Delivery successfully created',
      selectPartner: 'Select Partner',
      selectStandort: 'Select Location',
      selectProdukt: 'Select Product',
      onlyWithNachweise: 'Show only deliveries with evidence',
      filter: {
        title: 'Filter',
        apply: 'Apply',
        reset: 'Reset',
        sendMail: 'Send',
        sendMailTooltip: 'To send, filter by partner',
        nr: 'Nr',
        standort: 'Location',
        produkt: 'Product',
        partner: 'Customer',
        zeitraum: 'Date range',
        allProducts: '(all products)',
        allStandorte: '(all locations)',
        allPartners: '(all customers)'
      },
      statusDescriptions: {
        open: 'The delivery is open and can be edited',
        locked: 'The delivery is locked and cannot be edited',
        inProgress: 'The delivery is currently being processed',
        completed: 'The delivery has been completed'
      },
      placeholders: {
        nr: 'Enter number',
        menge: 'Enter amount',
        uom_menge: 'Enter unit',
        biogehalt: 'Enter bio content',
        lieferdatum: 'Select delivery date',
        typ: 'Enter type',
        produkt_nr: 'Enter product no.',
        produkt_version: 'Enter product version',
        partner_nr: 'Enter partner no.',
        standort_nr: 'Enter location no.',
        contract_number: 'Enter contract number',
        status: 'Enter status',
        incoterm: 'Enter incoterm',
        vehicle_name: 'Enter vehicle name',
        kommentar: 'Enter comment',
        storniert: 'Cancelled (0/1)',
        manuelle_eingabe: 'Manual Entry (0/1)',
        searchPartner: 'Search partner...',
        searchStandort: 'Search location...',
        searchProdukt: 'Search product...',
        searchNr: 'Search for number...',
        searchName: 'Search for name...'
      },
      columns: {
        nr: 'Number',
        menge: 'Amount',
        uom_menge: 'Unit',
        uomMenge: 'Unit',
        einheit: 'Unit',
        biogehalt: 'Bio Content (%)',
        lieferdatum: 'Delivery Date',
        typ: 'Type',
        produkttyp: 'Product Type',
        produkt: 'Product',
        produkt_nr: 'Product No.',
        produktNr: 'Product No.',
        produkt_version: 'Product Version',
        partner: 'Partner',
        partner_nr: 'Partner No.',
        partnerNr: 'Partner No.',
        partner_version: 'Partner Version',
        standort: 'Location',
        standort_nr: 'Location No.',
        standortNr: 'Location No.',
        standortCode: 'Location Code',
        standort_version: 'Location Version',
        mandantName: 'Client',
        mandantLand: 'Client Country',
        status: 'Status',
        status_name: 'Status Name',
        statusCode: 'Status Code',
        produktgruppe: 'Product Group',
        produkt_gruppe: 'Product Group',
        produktgruppe_name: 'Product Group Name',
        contract_number: 'Contract Number',
        contractNumber: 'Contract Number',
        kommentar: 'Comment',
        manuelle_eingabe: 'Manual Entry',
        manuelleEingabe: 'Manual Entry',
        incoterm: 'Incoterm',
        incoterm_name: 'Incoterm Name',
        incotermName: 'Incoterm Name',
        vehicle_name: 'Vehicle Name',
        vehicleName: 'Vehicle Name',
        kartennummer: 'Card Number',
        storniert: 'Cancelled',
        stornoParentId: 'Storno Parent ID'
      },
      sendReport: {
        tooltip: 'Send certificate',
        title: 'Send certificates',
        text: 'You can send the certificate to multiple recipients by entering multiple email addresses separated by commas.',
        singleWasSent: 'Certificate is being prepared.',
        bulkWasSent: 'Certificates are being prepared.',
        generalError: 'An error has occurred; certificates could not be sent.',
        notSamePartnerError: 'Certificates can only be sent to the same partner.',
        missingToRecipients: 'No recipient specified.',
        ablieferungNotFound: 'Delivery not found.',
        noAblieferungenFound: 'No delivery found.',
        missingReportName: 'No certificate template could be found.',
        containsAblieferungWithoutNachweis:
          'At least one delivery does not contain any certificate.',
        containsMoreThanOnePartner: 'Certificates can only be sent to one filtered partner.',
        ablieferungHasNoNachweis: 'Delivery does not include certificate.',
        containsUnclosedAblieferung: 'At least one delivery has not been completed.',
        ablieferungNotClosed: 'Delivery is not complete.',
        exceedsMaxAllowedReports: 'A maximum of {maxCount} proofs may be sent at one time.'
      },
      nachweise: {
        available: 'Available Certificates',
        assigned: 'Assigned Certificates',
        noAvailable: 'No available certificates',
        noAssigned: 'No assigned certificates',
        assign: 'Assign',
        assignSuccess: 'Certificate successfully assigned',
        removeSuccess: 'Certificate successfully removed',
        volumen: 'Volume',
        anteil: 'Share',
        volumenPlaceholder: 'Enter volume',
        anteilPlaceholder: 'Enter share',
        addNew: 'Add certificate',
        assignTitle: 'Assign certificate',
        requiredBioAmount: 'Required bio amount',
        assignedAmount: 'Assigned amount',
        remainingAmount: 'Remaining required amount',
        availableAmount: 'Available amount',
        assignAmount: 'Amount to assign',
        nr: 'Certificate No.',
        detailView: 'Detail view',
        tableView: 'Table view',
        createdAt: 'Created at',
        produkt: 'Product',
        produktNr: 'Product No.',
        produktgruppe: 'Product Group',
        produktgruppe_name: 'Product Group Name',
        lieferdatum: 'Delivery Date',
        available_volumen: 'Available volume',
        downloadReport: 'Download certificate'
      },
      downloadReport: 'Download delivery certificate'
    },
    abholung: {
      title: 'Collections',
      noData: 'No collections.',
      editTitle: 'Edit Collection',
      createTitle: 'Create Collection',
      deleteTitle: 'Delete Collection',
      deleteConfirm: 'Are you sure you want to delete this collection?',
      addNachweis: 'Add Certificate',
      removeNachweis: 'Remove Certificate',
      noNachweise: 'No certificates available',
      filter: {
        title: 'Filter',
        apply: 'Apply',
        reset: 'Reset',
        nr: 'Nr',
        partner: 'Partner',
        produkt: 'Product',
        lieferant: 'Supplier',
        zeitraum: 'Date range',
        allProducts: '(all products)',
        allPartners: '(all partners)'
      },
      placeholders: {
        selectDate: 'Select date',
        nr: 'Enter number',
        menge: 'Enter amount',
        volumen: 'Enter volume',
        anteil: 'Enter share',
        produkt: 'Product',
        lieferstelleNr: 'Enter delivery point no.',
        lieferstelleName: 'Enter delivery point name',
        selectLieferstelle: 'Select delivery point',
        ablieferungId: 'Enter delivery ID',
        ablieferungNr: 'Enter delivery no.',
        produktgruppe: 'Enter product group',
        abgangProduktNr: 'Enter outgoing product no.',
        abgangProduktName: 'Enter outgoing product name',
        produkttyp: 'Enter product type'
      },
      columns: {
        id: 'ID',
        nr: 'Collection No',
        bilanzierungNr: 'Accounting Nr',
        lieferdatum: 'Delivery Date',
        lieferstelleNr: 'Delivery Point No',
        lieferstelleName: 'Delivery Point Name',
        lieferstelle: 'Delivery Point',
        lieferant: 'Supplier',
        lieferantNr: 'Supplier No',
        contractNumber: 'Contract Nr.',
        mandantName: 'Mandant',
        mandantLand: 'Country',
        standortCode: 'Site Code',
        ablieferungId: 'Shipment ID',
        ablieferungNr: 'Shipment No',
        produkt: 'Product',
        produktNr: 'Product No',
        produktgruppe: 'Product Group',
        produktgruppe_name: 'Product Group Name',
        produktgruppeName: 'Product Group Name',
        abgangProdukt: 'Outgoing Product',
        abgangProduktNr: 'Outgoing Product No',
        abgangProduktName: 'Outgoing Product Name',
        produkttyp: 'Product Type',
        produktTyp: 'Product Type',
        produkttyp_name: 'Product Type Name',
        produktTypName: 'Product Type Name',
        kraftstoffmenge: 'Fuel Amount',
        menge: 'Amount',
        volumen: 'Amount',
        volumenVerbleibend: 'Remaining Amount',
        anteil: 'Share',
        actions: 'Actions'
      },
      verknuepfungen: {
        title: 'Link Deliveries',
        aktuelleVerknuepfungen: 'Current Links',
        keineVerknuepfungen: 'No deliveries linked',
        einlieferungenAuswaehlen: 'Select Deliveries',
        keineEinlieferungenVerfuegbar: 'No matching deliveries available',
        verfuegbareEinlieferungen: 'Available Deliveries'
      },
      einlieferungen: {
        title: 'Deliveries',
        aktuelleVerknuepfungen: 'Current Links',
        keineVerknuepfungen: 'No deliveries linked',
        einlieferungenAuswaehlen: 'Select Deliveries',
        keineEinlieferungenVerfuegbar: 'No matching deliveries available',
        verfuegbareEinlieferungen: 'Available Deliveries',
        columns: {
          nr: 'Number',
          entladedatum: 'Unloading Date',
          entladeneMenge: 'Unloaded Amount',
          typ: 'Type'
        }
      },
      nachweise: {
        title: 'Certificates',
        nachweis: 'Certificate',
        add: 'Add certificate',
        id: 'ID',
        nachweisNr: 'Certificate No',
        nnwAnteil: 'NNW Share',
        thgEmission: 'GHG Emission',
        attributAnnexIx: 'Attribute Annex',
        anbauland: 'Origin Country',
        rohstoff: 'Raw Material',
        biomasseArt: 'Biomass Type',
        biomasseCode: 'Biomass Code',
        nnwEnergie: 'NNW Energy',
        nnwProduktName: 'NNW Product Name',
        nnwProduktNr: 'NNW Product No',
        zertifizierungssystem: 'Certification System'
      },
      validation: {
        nachweisRequired: 'At least one certificate is required',
        nachweisNrRequired: 'Certificate No is required',
        lieferstelleRequired: 'Delivery point is required',
        produktgruppeRequired: 'Product group is required',
        mengeRequired: 'Fuel amount is required'
      },
      selectLieferstelle: 'Select delivery point',
      selectProduktTyp: 'Select product type',
      selectProduktGruppe: 'Select product group',
      selectProdukt: 'Select product'
    },
    einlieferungen: {
      title: 'Deliveries',
      noData: 'No deliveries.',
      editTitle: 'Edit delivery',
      createTitle: 'Create delivery',
      verknuepfteAbholung: 'Linked Collection',
      aktuelleVerknuepfung: 'Current Link',
      keineVerknuepfung: 'No collection linked',
      verfuegbareAbholungen: 'Available Collections',
      abholungAuswaehlen: 'Select Collection',
      keineAbholungenVerfuegbar: 'No matching collections available',
      confirmNrChange: 'Do you really want to change the delivery number?',
      selectPartner: 'Select Partner',
      selectStandort: 'Select Location',
      selectProdukt: 'Select Product',
      filter: {
        title: 'Filter',
        apply: 'Apply',
        reset: 'Reset',
        nr: 'Nr',
        standort: 'Location',
        produkt: 'Product',
        partner: 'Partner',
        zeitraum: 'Date range',
        allProducts: '(all products)',
        allStandorte: '(alle locations)',
        allPartners: '(alle partners)'
      },
      placeholders: {
        searchPartner: 'Search partner...',
        searchStandort: 'Search location...',
        searchProdukt: 'Search product...',
        searchNr: 'Search for number...',
        searchName: 'Search for name...',
        selectDate: 'Select date',
        selectUom: 'Select unit',
        selectTyp: 'Select type',
        selectProduktgruppe: 'Select product group',
        nr: 'Enter number',
        typ: 'Enter type',
        entladeneMenge: 'Enter amount',
        biogehalt: 'Enter bio content',
        produktgruppe: 'Enter product group',
        contractNumber: 'Enter contract number',
        incoterm: 'Enter incoterm',
        vehicleName: 'Enter vehicle name',
        kommentar: 'Enter comment'
      },
      abholungen: {
        columns: {
          nr: 'Collection No',
          lieferdatum: 'Delivery Date',
          kraftstoffmenge: 'Fuel Amount',
          volumen: 'Volume',
          verfuegbaresVolumen: 'Available Volume',
          produktgruppe: 'Product Group',
          lieferstelle: 'Delivery Point',
          ablieferungNr: 'Shipment Number'
        }
      },
      columns: {
        nr: 'Delivery No',
        typ: 'Type',
        biogehalt: 'Bio Content (%)',
        entladeneMenge: 'Unloaded Amount',
        uomEntladeneMenge: 'Unit (unloaded)',
        geladeneMenge: 'Loaded Amount',
        uomGeladeneMenge: 'Unit (loaded)',
        beladedatum: 'Loading Date',
        unitOfMeasure: 'Unit',
        entladedatum: 'Unloading Date',
        status: 'Status',
        statusName: 'Status Name',
        statusCode: 'Status Code',
        mandantName: 'Client',
        mandantLand: 'Client Country',
        manuelleEingabe: 'Manual Entry',
        partnerNr: 'Partner No',
        partner: 'Partner',
        partnerVersion: 'Partner Version',
        standortNr: 'Location No',
        standort: 'Location',
        standortCode: 'Location Code',
        standortVersion: 'Location Version',
        produktNr: 'Product No',
        produkt: 'Product',
        produktVersion: 'Product Version',
        produktgruppe: 'Product Group',
        produktgruppeName: 'Product Group Name',
        produkttyp: 'Product Type',
        contractNumber: 'Contract Number',
        incoterm: 'Incoterm',
        incotermName: 'Incoterm Name',
        vehicleName: 'Vehicle Name',
        kommentar: 'Comment',
        storniert: 'Cancelled',
        stornoParentId: 'Cancel Parent ID',
        commodityGroup: 'Commodity Group',
        productCode: 'Product Code',
        maxVolumen: 'Max Volume'
      },
      statusDescriptions: {
        open: 'The delivery is open and can be edited',
        locked: 'The delivery is locked and cannot be edited',
        inProgress: 'The delivery is currently being processed',
        completed: 'The delivery has been completed'
      },
      validation: {
        requiredFields: 'Please fill in all required fields',
        invalidNumber: 'Please enter a valid number',
        invalidDate: 'Please enter a valid date',
        invalidAmount: 'Please enter a valid amount'
      },
      messages: {
        createSuccess: 'Delivery was successfully created',
        updateSuccess: 'Delivery was successfully updated',
        deleteSuccess: 'Delivery was successfully deleted',
        linkSuccess: 'Link was successfully created',
        unlinkSuccess: 'Link was successfully removed'
      }
    },
    standorte: {
      title: 'Locations',
      createTitle: 'Create New Location',
      editTitle: 'Edit Location',
      deleteTitle: 'Delete Location',
      deleteConfirm: 'Do you really want to delete this location?',
      columns: {
        nr: 'Number',
        name: 'Name',
        strasse: 'Street',
        hausNr: 'House Number',
        plz: 'Postal Code',
        stadt: 'City',
        land: 'Country',
        code: 'Code',
        anlage: 'Plant-Nr',
        quota: 'Quota?'
      }
    },
    produkte: {
      title: 'Products',
      createTitle: 'Create New Product',
      editTitle: 'Edit Product',
      deleteTitle: 'Delete Product',
      deleteConfirm: 'Do you really want to delete this product?',
      columns: {
        nr: 'Number',
        name: 'Name',
        biogehalt: 'Bio Content',
        lcv: 'Low calorific value (MJ/kg or MJ/L)',
        beschreibung: 'Description',
        produktgruppe: 'Product Group',
        produkttyp: 'Product Type',
        produktgruppeCode: 'Product group code',
        produkttypCode: 'Product type code',
        thg: 'GHG',
        version: 'Version',
        mandantName: 'Client',
        mandantLand: 'Client country',
        status: 'Status',
        kommentar: 'Comment'
      },
      status: {
        aktiv: 'Active',
        inaktiv: 'Inactive'
      },
      produktgruppen: {
        diesel: 'Diesel',
        benzin: 'Gasoline',
        biodiesel: 'Biodiesel',
        bioethanol: 'Bioethanol',
        hvo: 'HVO',
        pflanzenoel: 'Plant Oil'
      }
    },
    zertifizierungen: {
      title: 'Certifications',
      createTitle: 'New certification',
      deleteTitle: 'Delete certification',
      deleteConfirm: 'Are you sure you want to delete this certification?',
      updateTitle: 'Update certification',
      columns: {
        nr: 'Nr',
        von: 'Valid from',
        bis: 'Valid until'
      }
    },
    nachweisbescheinigungen: {
      title: 'Certification Records',
      noData: 'No records.',
      createTitle: 'New certificate',
      editTitle: 'Edit certificate',
      deleteTitle: 'Delete certificate',
      deleteConfirm: 'Do you really want to delete this certificate?',
      filter: {
        title: 'Filter',
        apply: 'Apply',
        reset: 'Reset',
        standort: 'Location',
        produkt: 'Product',
        zeitraum: 'Date range',
        allProducts: '(all products)',
        allStandorte: '(all locations)'
      },
      detail: {
        title: 'Certificate Details',
        basicInfo: 'Basic Information',
        productInfo: 'Product Information',
        linkedDeliveries: 'Linked Deliveries',
        linkedPickups: 'Linked Collections',
        abholungInfo: 'Collection Information',
        abholungNachweise: 'Certificates of the Collection'
      },
      tabs: {
        general: 'General',
        einlieferungen: 'Deliveries',
        abholungen: 'Collections',
        ablieferungen: 'Disposals'
      },
      columns: {
        id: 'ID',
        nachweisNr: 'Certificate No',
        volumen: 'Volume',
        volumenVerbleibend: 'Available Volume',
        produktNr: 'Product No',
        produktgruppe: 'Product Group',
        produktgruppeName: 'Product Group Name',
        produkt: 'Product',
        produkttyp: 'Product Type',
        standort: 'Location',
        standortNr: 'Location No',
        standortCode: 'Location Code',
        tauschpartner: 'Partner',
        partnerNr: 'Partner No',
        einlieferungNr: 'Delivery No',
        einlieferungId: 'Delivery ID',
        abholungId: 'Collection ID',
        mandantName: 'Tenant',
        mandantLand: 'Tenant Country',
        lieferdatum: 'Delivery Date',
        referenzNachweisNr: 'Reference Certificate No',
        nnwAnteil: 'NNW Share',
        nnwEnergie: 'NNW Energy',
        thgEmission: 'GHG Emission',
        nnwProduktName: 'NNW Product',
        nnwProduktNr: 'NNW Product No',
        rohstoff: 'Raw Material',
        biomasseArt: 'Biomass Type',
        biomasseCode: 'Biomass Code',
        anbauland: 'Cultivation Country',
        zertifizierungsystem: 'Certification System'
      },
      endNachweise: {
        title: 'End Certificates'
      },
      placeholders: {
        nachweisNr: 'Enter certificate no',
        volumen: 'Enter volume',
        volumenVerbleibend: 'Enter available volume',
        produktNr: 'Enter product no',
        produktgruppe: 'Enter product group',
        produktgruppeName: 'Enter product group name',
        produkt: 'Enter product',
        lieferdatum: 'Select delivery date'
      }
    },
    nachweisverteilung: {
      title: 'Certificate allocation',
      resetTitle: 'Reset allocation',
      resetText: 'Are you sure you want to reset the allocation?',
      invalidTitle: 'Incomplete allocation',
      invalidText:
        'Allocation data cannot be saved. At least one delivery still has unallocated quantity.',
      saveTitle: 'Save allocation data',
      saveText: 'Are you sure you want to save the allocation data?',
      filter: {
        title: 'Filter',
        apply: 'Apply',
        reset: 'Reset',
        nr: 'Nr',
        standort: 'Location',
        produkt: 'Product',
        partner: 'Customer',
        zeitraum: 'Date range',
        allProducts: '(all products)',
        allStandorte: '(all locations)',
        allPartners: '(all customers)'
      },
      messages: {
        saved: 'Allocation data has been saved successfully.',
        saveError: 'Allocation data could not be saved.'
      }
    },
    benutzer: {
      deleteTitle: 'Delete User',
      deleteConfirm: 'Do you really want to delete this user?',
      userDetails: {
        login: 'Login',
        name: 'Name'
      }
    },
    tankstelleBestand: {
      title: 'Gas Station Overview',
      simulateDelivery: 'Simulate Delivery',
      tankDetails: 'Tank Details',
      productDetails: 'Product Details',
      deliveryHistory: 'Delivery History',
      tankLevel: 'Fill Level',
      capacity: 'Capacity',
      currentLevel: 'Current Level',
      lastDelivery: 'Last Delivery',
      noDeliveries: 'No deliveries available',
      liters: 'Liters',
      date: 'Date',
      amount: 'Amount',
      supplier: 'Supplier',
      product: 'Product',
      bioContent: 'Bio Content',
      deliveryDetails: 'Delivery Details',
      deliveryNumber: 'Delivery Number',
      deliveryDate: 'Delivery Date',
      deliveryAmount: 'Delivery Amount',
      certificates: 'Certificates',
      certificateNumber: 'Certificate Number',
      certificateAmount: 'Certificate Amount',
      certificatePercentage: 'Certificate Percentage',
      noCertificates: 'No certificates available',
      overviewTab: 'Overview',
      tanksTab: 'Tanks',
      visualizationTitle: 'Gas Station Overview',
      tankVisualization: 'Tank Visualization',
      tankDescription: 'Stores deliveries and their GHG savings',
      pumpVisualization: 'Pump Visualization',
      thgValue: 'GHG Value',
      recentDeliveries: 'List of last 10 deliveries',
      detailView: 'Detail View',
      supplyChainView: 'see supply chain visualization',
      levelLineDescription: 'The blue area shows the current allocation of certificates',
      newDeliveryInfo: 'When a new delivery arrives, the tank level increases.',
      nachweisverfolgung: 'Certificate Tracking',
      deliveryStatus: {
        withCertificate: 'With final certificate',
        withoutCertificate: 'Without final certificate',
        noCertificate: 'No certificate'
      },
      einlieferungStatus: {
        notLinked: 'Not linked',
        dummyCertificate: 'Provisional certificate',
        realCertificate: 'Final certificate'
      },
      modalWarning: {
        title: 'No certificates available',
        content:
          'There are no certificates stored in the system for this delivery. The certificate tracking will not be able to display any data.',
        cancel: 'Cancel',
        proceed: 'Proceed anyway'
      },
      thgSavings: {
        realSaving: 'Real Saving',
        projectedSaving: 'Projected Saving',
        comparison: 'This saving is equivalent to:',
        carTrips: 'Car trips (100 km)',
        flights: 'Flights (500 km)',
        meatConsumption: 'kg meat consumption'
      },
      deliveryStatusLabel: 'Status of deliveries:',
      tankStatusLabel: 'Tank status indicator:',
      tankStatus: {
        sufficient: 'Sufficiently available',
        followUpAvailable: 'Sufficient with successor',
        lowFollowUpPending: 'Low availability with successor',
        lowNoFollowUp: 'Low availability without successor',
        inactive: 'No active delivery',
        noDelivery: 'No deliveries available',
        provisional: 'Provisional certificate'
      },
      results: {
        recentDeliveries: 'The 10 most recent deliveries are displayed.',
        onlyProduct: 'Only product:',
        clickForDetails: 'Click on a delivery to view details'
      },
      noData: 'No GHG data available',
      thgInfoModal: {
        title: 'GHG Savings:',
        close: 'Close'
      },
      filter: {
        title: 'Select Gas Station & Product',
        loading: 'Loading gas station data...',
        error: {
          title: 'Error loading data',
          retry: 'Try again',
          defaultMessage: 'Please try again later.'
        }
      },
      ablieferungen: {
        filterTitle: 'Filtered by product:',
        number: 'No:',
        showFullNumber: 'Show full delivery number',
        liter: 'l'
      },
      pump: {
        thgSaving: 'GHG SAVING'
      },
      actions: {
        details: 'Details',
        supplyChain: 'Supply Chain'
      },
      einlieferungen: {
        date: 'Date',
        ablieferungId: 'DELIVERY ID:',
        generalInfo: 'General Information',
        id: 'ID',
        maxVolume: 'Max. Volume',
        address: 'Location address',
        recentDeliveries: 'Recent deliveries',
        deliveryNumber: 'Delivery No',
        noAvailable: 'No deliveries available',
        title: 'Delivery details',
        noDataAvailable: 'No data available.',
        receiver: 'Receiver',
        unknown: 'Unknown',
        deliveryDate: 'Delivery date',
        product: 'Product',
        thgCertificate: 'GHG certificate',
        available: 'Available',
        notAvailable: 'Not available',
        location: {
          title: 'Location information',
          name: 'Name',
          address: 'Address',
          place: 'Place',
          country: 'Country',
          number: 'Location No'
        },
        receiverInfo: {
          title: 'Receiver information',
          name: 'Name',
          address: 'Address',
          place: 'Place',
          contact: 'Contact person',
          phone: 'Phone',
          email: 'Email'
        },
        thgInfo: {
          title: 'GHG certificate information',
          id: 'Certificate ID',
          saving: 'Saving',
          source: 'Source material',
          date: 'Issued on',
          status: 'Status',
          uerValue: 'UER value'
        },
        extendedInfo: {
          title: 'Extended information',
          bioContent: 'Bio content',
          productType: 'Product type',
          productGroup: 'Product group'
        }
      }
    },
    nachweisverfolgung: {
      title: 'Certificate Tracking',
      filter: {
        title: 'Filter',
        apply: 'Apply',
        reset: 'Reset',
        standort: 'Location',
        produkt: 'Product',
        zeitraum: 'Date range',
        allProducts: '(all products)',
        allStandorte: '(all locations)'
      },
      columns: {
        datum: 'Date',
        produkt: 'Product',
        menge: 'Amount',
        empfaenger: 'Recipient'
      },
      viewTraceability: 'Show Certificate Tracking',
      noData: 'No deliveries available',
      table: {
        certificateNumber: 'Certificate Number',
        productType: 'Product Type',
        amount: 'Amount',
        date: 'Date',
        supplier: 'Supplier',
        status: 'Status',
        details: 'Details'
      },
      details: {
        title: 'Certificate Tracking Details',
        certificate: 'Certificate',
        deliveries: 'Deliveries',
        stations: 'Gas Stations',
        path: 'History',
        origin: 'Origin',
        destination: 'Destination',
        intermediate: 'Intermediate Stations',
        noData: 'No data available'
      },
      status: {
        active: 'Active',
        used: 'Used',
        expired: 'Expired',
        pending: 'Pending'
      },
      legend: {
        title: 'Legend',
        abholung: 'Collection Certificate',
        ablieferung: 'Delivery Certificate',
        einlieferung: 'Incoming Certificate'
      },
      modal: {
        details: 'Details',
        description: 'Description',
        document: 'Document',
        documentId: 'Document ID',
        date: 'Date',
        noDocument: 'No document linked',
        close: 'Close'
      }
    },
    bestaende: {
      title: 'Inventory',
      noData: 'No inventory.',
      createTitle: 'New inventory',
      editTitle: 'Edit inventory',
      deleteTitle: 'Delete inventory',
      deleteConfirm: 'Do you really want to delete this inventory?',
      delete_title: 'Delete inventory',
      delete_confirmation: 'Do you really want to delete inventory #{id} ({produkt})?',
      delete_warning: 'This action cannot be undone.',
      filter: {
        title: 'Filter',
        apply: 'Apply',
        reset: 'Reset',
        standort: 'Location',
        produkt: 'Product',
        zeitraum: 'Date range',
        allProducts: '(all products)',
        allStandorte: '(all locations)'
      },
      columns: {
        id: 'ID',
        datum: 'Date',
        standort: 'Location',
        standortNr: 'Location No',
        standortCode: 'Location Code',
        standort_nr: 'Location No',
        produkt: 'Product',
        produktNr: 'Product No',
        produkt_nr: 'Product No',
        volumen: 'Volume',
        fuellstand: 'Fill level',
        mandant: 'Tenant',
        mandantName: 'Tenant',
        mandantLand: 'Tenant Country',
        deliveryVolumen: 'Delivery Volume',
        deliveryStart: 'Delivery Start',
        deliveryEnd: 'Delivery End'
      },
      placeholders: {
        searchProdukt: 'Search product...',
        searchStandort: 'Search location...',
        selectDate: 'Select date'
      },
      selectProdukt: 'Select product',
      selectStandort: 'Select location',
      errors: {
        loadFailed: 'Error loading inventory',
        updateFailed: 'Error updating inventory',
        createFailed: 'Error creating inventory',
        missingFields: 'Please fill in all required fields'
      },
      success: {
        createSuccess: 'Inventory was successfully created',
        updateSuccess: 'Inventory was successfully updated',
        deleteSuccess: 'Inventory was successfully deleted'
      }
    },
    mandanten: {
      title: 'Tenant Management',
      addMandant: 'Create Tenant',
      editMandant: 'Edit Tenant',
      deleteMandant: 'Delete Tenant',
      confirmDelete:
        'Are you sure you want to delete the tenant "{name}"? This action cannot be undone.',
      userSection: 'Users',
      addUser: 'Add User',
      editUser: 'Edit User',
      noUsers: 'No users found',
      status: {
        active: 'active',
        inactive: 'inactive',
        activate: 'Activate',
        deactivate: 'Deactivate'
      },
      columns: {
        name: 'Tenant',
        id: 'ID',
        email: 'Email',
        strasse: 'Street',
        hausNr: 'House-Nr',
        plz: 'Postal Code',
        stadt: 'City',
        land: 'Country',
        status: 'Status',
        zertifizierung: 'Certification-No'
      },
      address: 'Address',
      errors: {
        loadFailed: 'The tenants could not be loaded. Please try again later.',
        saveFailed: 'The tenant could not be saved. Please try again later.',
        statusChangeFailed: 'The status could not be changed. Please try again later.',
        deleteFailed: 'The tenant could not be deleted. Please try again later.',
        loadUsersFailed: 'The users could not be loaded.',
        saveUserFailed: 'The user could not be saved.'
      }
    },
    import: {
      title: 'Import',
      file: 'File',
      uploadFile: 'Upload file',
      upload: 'Upload',
      type: 'Type',
      import: 'Import data',
      confirm: 'Do you really want to import the data?',
      inbound: 'Inbound data',
      outbound: 'Outbound data',
      messages: 'Import messages',
      columns: {
        importStatus: 'Status',
        importError: 'Error',
        importIdentifier: 'Identifier',
        insertDate: 'Inserted',
        importDate: 'Import attempt',
        importCodes: 'Import codes'
      }
    },
    ytd: {
      title: 'YTD Overview',
      jahr: 'Year',
      produkt: 'Product',
      selectProdukt: '(please select a product)',
      selectJahr: '(please select a year)',
      columns: {
        airport: 'airport',
        airlines: 'airlines',
        ytdPocMenge: 'YTD PoC-Quantity',
        ytdSollMenge: 'YTD Mandatory-Quantity',
        ytdDiffMenge: 'YTD Difference',
        ytdZusatzMenge: 'YTD Voluntary Quantity',
        ytdPocTotalMenge: 'YTD PoC-Quantity (all locations)',
        ytdSollTotalMenge: 'YTD Mandatory-Quantity (all locations)'
      }
    }
  },
  entities: {
    produkt: 'product',
    standort: 'location',
    partner: 'partner',
    abholung: 'collection',
    einlieferung: 'delivery',
    ablieferung: 'transaction',
    bestand: 'inventory',
    nachweisbescheinigung: 'certificate',
    zertifikat: 'certificate(s)',
    inbound: 'inbound data',
    outbound: 'outbound data',
    bilanz: 'allotment',
    nachweis: 'certificate',
    zertifizierung: 'certification'
  },
  errors: {
    loading: 'Error loading {entity}',
    invalidId: 'Invalid ID',
    invalidData: 'Invalid data',
    createError: 'Could not create {entity}.',
    updateError: 'Could not update {entity}.',
    deleteError: 'Could not delete {entity}.',
    importError: 'Could not import data.',
    loadError: 'Data could not be loaded.',
    downloadError: '{entity} could not be downloaded.',
    notFound: '{entity} could not be found.',
    uploadError:
      'File could not be uploaded/processed. It may contain incorrect data or data errors.',
    unexpected: 'An unexpected error occurred',
    serverError: 'The server is not reachable',
    validationError: 'Please check your input',
    accessDenied: 'Access denied',
    saving: 'Error saving {entity}',
    deleting: 'Error deleting {entity}',
    verknuepfen: 'Error linking',
    alreadyLinked: 'This delivery is already linked to collection {nr}'
  },
  warning: {
    missingOrInvalid: 'Missing or invalid values in: ',
    wartungsfenster: {
      sessionWillBeTerminated: 'Maintenance active - Your session will end shortly.'
    }
  },
  success: {
    created: '{entity} was successfully created.',
    updated: '{entity} was successfully updated.',
    deleted: '{entity} was successfully deleted.',
    imported: 'Data has been successfully imported.',
    saved: 'Data has been successfully saved.',
    verknuepft: 'Link was successfully established.',
    added: '{entity} was successfully added.'
  },
  dashboard: {
    title: 'Dashboard',
    stats: {
      users: 'Active Users',
      deliveries: 'Deliveries',
      products: 'Products',
      documents: 'Documents'
    },
    recent_activities: 'Recent Activities',
    activities: {
      new_user: 'New user registered',
      document_updated: 'Document updated',
      delivery_completed: 'Delivery completed'
    },
    system_alerts: 'System Alerts',
    alerts: {
      system_update: 'System update scheduled',
      disk_space: 'Server disk space running low'
    },
    welcome: 'Welcome to CEETRAC',
    welcome_message:
      'Your central portal for sustainability certificates and supply chain transparency'
  },
  components: {
    pagination: {
      back: 'Back',
      next: 'Next',
      showing: 'Showing {start} to {end} of {total} results'
    },
    importCodeEditor: {
      title: 'Import Codes',
      addCode: 'Add Code',
      codePlaceholder: 'Enter import code',
      noCodes: 'No import codes available',
      editCode: 'Edit Code'
    }
  }
};
